﻿<div *ngIf="!isViewMoreClicked" class="mt-1">
  <app-data-table
    #bulkTable
    [columnChooser]="true"
    [columns]="bulkColumns"
    [data]="bulkOrders"
    [totalRecords]="totalRecords"
    [rows]="rowsPerPage"
    [paginator]="true"
    [lazy]="true"
    [emptyMessage]="noRecordMsg || 'No Records Found'"
    [getRowClass]="rowClassFor"
    [analyticsTab]="'Bulk'"
    (columnSort)="sortBulk($event)"
    (pageChange)="onPageChange($event)"
    (rowsChange)="onRowsPerPageChange($event)"
    (rowClick)="onViewMore($event)"
  >
    <ng-template appTableCell="status" let-row>
      <app-status-badge [status]="row.status"></app-status-badge>
    </ng-template>

    <ng-template appTableCell="action" let-row>
      <div class="action-buttons" appRowActionStop>
        <a class="viewmore" appIconAction (click)="onViewMore(row)"
          ><i
            class="pi pi-eye"
            pTooltip="View Orders"
            tooltipPosition="top"
          ></i
        ></a>

        <a
          class="viewmore"
          (click)="getBulkOrderSummary(row.id)"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          ><i
            class="pi pi-book"
            pTooltip="View Summary"
            tooltipPosition="top"
          ></i
        ></a>
        <a
          *ngIf="row.status === 'WAITING_FOR_APPROVAL'"
          class="viewmore"
          (click)="getBulkOrderExcel(row.id)"
          ><i
            class="pi pi-file-excel"
            pTooltip="View Bulk Excel"
            tooltipPosition="top"
          ></i
        ></a>

        <a
          *ngIf="row.status != 'WAITING_FOR_APPROVAL'"
          class="viewmore"
          (click)="getBulkOrderPdf(row.id)"
          ><i
            class="pi pi-download"
            pTooltip="Download Bulk Pdf"
            tooltipPosition="top"
          ></i
        ></a>
      </div>
    </ng-template>

    <ng-template appTableCell="progress" let-row let-i="index">
      <div class="progress" style="height: 1.5rem; width: 5rem" appRowActionStop>
        <div
          class="progress-bar"
          role="progressbar"
          [style.width.%]="progressPercentage[i]"
          [ngStyle]="{
            'min-width.%': progressPercentage[i] > 0 ? 20 : null
          }"
          aria-valuenow="ordersCount?.completed_orders"
          aria-valuemin="0"
          [attr.aria-valuemax]="ordersCount?.total_orders"
          tooltipPosition="top"
          pTooltip="{{ progressBarTooltip[i] }}"
        >
          <span class="progress-percent">
            {{ progressPercentage[i] | number : "1.0-0" }}%
          </span>
        </div>

        <div
          *ngIf="progressPercentage[i] > 0 && progressPercentage[i] < 100"
          class="remaining-percentage"
          [style.width.%]="100 - progressPercentage[i]"
          [ngStyle]="{
            'min-width.%': progressPercentage[i] > 80 ? 20 : null
          }"
          style="top: 0; left: progressPercentage[i]; color: black"
          tooltipPosition="top"
          pTooltip="{{ progressBarTooltip[i] }}"
        >
          {{ 100 - progressPercentage[i] | number : "1.0-0" }}%
        </div>

        <div
          *ngIf="progressPercentage[i] === 0"
          class="remaining-percentage"
          tooltipPosition="top"
          pTooltip="{{ progressBarTooltip[i] }}"
          [style.width.%]="100 - progressPercentage[i]"
          style="top: 0; left: progressPercentage[i]; color: black"
        >
          0%
        </div>
      </div>
    </ng-template>
  </app-data-table>
</div>

<div
  *ngIf="isViewMoreClicked"
  style="border: 1px solid #e8ecf3; border-radius: 10px"
  class="mt-1"
>
  <div class="flex_row m-2">
    <div class="col-lg-3 col-sm-3 col-md-3 flex_row">
      <span style="font-weight: 600; font-size: 14px">Bulk order number: </span>
      <label class="me-1 ms-1 font_size_14">{{
        this.selectedBulkOrder?.bulk_order
      }}</label>
    </div>

    <div class="col-lg-3 col-sm-3 col-md-3 flex_row">
      <span style="font-weight: 600; font-size: 14px">Bulk order date: </span>
      <label class="me-1 ms-1 font_size_14">{{
        this.selectedBulkOrder?.created
      }}</label>
    </div>
    <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
      <p-button
        *ngIf="reviewMode && bulkOrderStatus === 'REJECTED'"
        class="me-2"
        label="Re-Initiate All"
        (click)="approveAll('reset')"
        icon="pi pi-folder-open"
        styleClass="p-button-sm-outline"
      ></p-button>
      <p-button
        *ngIf="reviewMode && bulkOrderStatus === 'WAITING_FOR_APPROVAL'"
        class="me-2"
        label="Approve All"
        (click)="approveAll('approve')"
        icon="bx bxs-check-circle"
        styleClass="p-button-sm-outline"
      ></p-button>

      <p-button
        *ngIf="reviewMode && bulkOrderStatus === 'WAITING_FOR_APPROVAL'"
        label="Reject All"
        icon="bx bxs-x-circle"
        (click)="approveAll('reject')"
        styleClass="p-button-sm me-2"
      ></p-button>
      <p-button
        class="me-2"
        label="Export"
        (click)="export()"
        icon="bx bx-export"
        styleClass="p-button-sm-outline"
      ></p-button>

      <p-button
        class="me-2"
        label="Export-ESBTR"
        icon="bx bx-export"
        styleClass="p-button-sm-outline"
        (click)="exportESBTR()"
      ></p-button>

      <p-button
        label="Back"
        (click)="onBackClick()"
        styleClass="p-button-sm"
      ></p-button>
      <app-column-chooser [table]="orderTable"></app-column-chooser>
    </div>
  </div>

  <div class="mt-1">
    <app-data-table
      #orderTable
      [columnChooser]="true"
      [columns]="orderColumns"
      [data]="orders"
      [totalRecords]="totalOrderRecords"
      [rows]="rowsPerPageForViewMore"
      [paginator]="true"
      [lazy]="true"
      emptyMessage="No Records Found"
      [getRowClass]="rowClassFor"
      (columnSort)="sort($event)"
      (pageChange)="onOrderPageChange($event)"
      (rowsChange)="onRowsPerPageChangeForViewMore($event)"
    >
      <ng-template appTableCell="status" let-row>
        <app-status-badge [status]="row.status"></app-status-badge>
      </ng-template>

      <ng-template appTableCell="action" let-row>
        <div>
          <a
            *ngIf="
              row.status === 'Waiting for Approval' ||
              row.status === 'Approval Pending'
            "
            class="viewmore"
            (click)="viewIndividualOrder(row, viewOrderData)"
            ><i
              class="pi pi-folder-open"
              pTooltip="Approval Pending"
              tooltipPosition="top"
            ></i
          ></a>
          <a
            *ngIf="row.status != 'Approval Pending'"
            class="viewmore"
            (click)="viewIndividualOrder(row, viewOrderData)"
            ><i class="pi pi-eye"></i
          ></a>
          <a
            *ngIf="
              row.status === 'Approval Pending' &&
              row?.order_type != 'Estamp'
            "
            class="viewmore clickable"
            (click)="viewPdfDocument(row)"
            pTooltip="Review Document"
            tooltipPosition="top"
            ><i class="pi pi-file-pdf"></i
          ></a>
        </div>
      </ng-template>
    </app-data-table>
  </div>
</div>

<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="p-3 modal-title">
        <p>Order Summary</p>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="container">
        <div class="row">
          <div class="col">
            <div class="r1">
              Total Orders:<span class="r1s">{{
                ordersCount?.total_orders
              }}</span>
            </div>
          </div>

          <div class="col">
            <div class="r1">
              In Progress:<span class="r1s">{{
                ordersCount?.in_progress
              }}</span>
            </div>
          </div>

          <div class="col">
            <div class="r1">
              Completed Orders:<span class="r1s">{{
                ordersCount?.completed_orders
              }}</span>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div *ngIf="ordersCount?.total_stamp != 0" class="col">
            <div class="r1">
              Total Number of Stamps:<span class="r1s">{{
                ordersCount?.total_stamp
              }}</span>
            </div>
          </div>

          <div *ngIf="ordersCount?.total_stamp != 0" class="col">
            <div class="r1">
              Total Stamp Amount:<span class="r1s"
                >₹ {{ ordersCount?.total_stamp_amount }}</span
              >
            </div>
          </div>

          <div class="col">
            <div class="r1">
              Total Signature:<span class="r1s">{{
                ordersCount?.total_signature
              }}</span>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <div class="r1">
              Completed Signature:<span class="r1s">{{
                ordersCount?.total_signature_completed
              }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Pending Signature:<span class="r1s">{{ pendingSignature }}</span>
            </div>
          </div>
          <div class="col">
            <!-- <div class="progress" style="height: 1rem; width: 4rem">
              <div class="progress-bar" role="progressbar" [style.width.%]="getProgressPercentage()"
                aria-valuenow="ordersCount?.completed_orders" aria-valuemin="0"
                [attr.aria-valuemax]="ordersCount?.total_orders" data-toggle="tooltip" title="{{ getTooltipText() }}">
              </div>
            </div> -->
          </div>
        </div>

        <!-- <div class="mt-2">
          <div class="progress" style="height: 1.5rem; width: 4rem">
            <div class="progress-bar" role="progressbar" [style.width.%]="getProgressPercentage()"
              aria-valuenow="ordersCount?.completed_orders" aria-valuemin="0"
              [attr.aria-valuemax]="ordersCount?.total_orders" data-toggle="tooltip" title="{{ getTooltipText() }}">
            </div>
          </div>

        </div> -->

        <div class="mb-4"></div>
      </div>

      <div class="p-3 modal-title">
        <p>Status Summary</p>
      </div>

      <div class="container mb-5">
        <div class="mt-1 table_styleing">
          <table class="table table-borderless">
            <thead class="modal-bg align-middle">
              <tr class="modal-bg">
                <th class="modal-bg" scope="col">State</th>
                <th class="modal-bg" scope="col">Total Order</th>
                <th class="modal-bg" scope="col">Completed Order</th>
                <th class="modal-bg" scope="col">Cancelled</th>
                <th
                  *ngIf="ordersCount?.total_stamp != 0"
                  class="modal-bg"
                  scope="col"
                >
                  Approval Pending
                </th>
                <th
                  *ngIf="ordersCount?.total_stamp != 0"
                  class="modal-bg"
                  scope="col"
                >
                  Waiting For Stamps
                </th>
                <th class="modal-bg" scope="col">In Progress</th>
                <th
                  *ngIf="ordersCount?.total_stamp != 0"
                  class="modal-bg"
                  scope="col"
                >
                  Total Amount
                </th>
              </tr>
            </thead>

            <tbody class="tablebody">
              <tr
                style="margin-top: 20px"
                *ngFor="let order of ordersCount?.state_status_data"
              >
                <td>{{ order.state }}</td>
                <td>{{ order.total_count }}</td>
                <td>{{ order.statuses.COMPLETED }}</td>
                <td>{{ order.statuses.CANCELLED || 0 }}</td>
                <td *ngIf="ordersCount?.total_stamp != 0">
                  {{ order.statuses.WAITING_FOR_APPROVAL || 0 }}
                </td>
                <td *ngIf="ordersCount?.total_stamp != 0">
                  {{
                    order.statuses.INITIATED + order.statuses.WAITING_FOR_STAMP
                  }}
                </td>
                <td>{{ order.statuses.IN_PROGRESS }}</td>
                <td *ngIf="ordersCount?.total_stamp != 0">
                  ₹ {{ order.total_stamp_duty }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Edit Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeEditOrderPopup()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="edit-modal-body">
      <form [formGroup]="commonFieldsOrderForm">
        <div class="flexRow">
          <div class="form_inputFields">
            <span class="form_field">
              Reference Number <span class="color_red">*</span></span
            >
            <input
              placeholder="Enter Reference Number"
              class="form-control"
              formControlName="referenceNumber"
              pInputText
              type="text"
              onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)
            || (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 32 || (event.charCode === 45)"
            />
            <span
              class="p-error"
              style="font-size: 0.5rem"
              *ngIf="
                submitted &&
                editEstampForm.get('referenceNumber')?.hasError('required')
              "
              >*Enter reference number</span
            >
          </div>
        </div>

        <div class="flexRow">
          <div class="form_inputFields">
            <span class="form_field ms-2"
              >Select State <span class="color_red">*</span></span
            >
            <div style="display: block">
              <app-dropdown
                class="custom-dropdown"
                [options]="stateData"
                formControlName="state"
                (onChange)="onEditStateChange($event)"
                placeholder="Select State"
                [filter]="true"
                filterBy="state_name"
                optionLabel="state_name"
                optionValue="id"
              ></app-dropdown>
            </div>
          </div>

          <div class="form_inputFields">
            <span class="form_field ms-2"
              >Select Branch <span class="color_red">*</span></span
            >
            <div style="display: block">
              <app-dropdown
                class="custom-dropdown"
                [options]="branchData"
                formControlName="branch"
                placeholder="Select Branch"
                [filter]="true"
                filterBy="name"
                optionLabel="name"
                optionValue="id"
              ></app-dropdown>
            </div>
          </div>
        </div>
      </form>

      <form [formGroup]="editEstampForm" class="mt-2">
        <span
          class="title_five ms-2"
          *ngIf="selectedOrderForEdit.estamp.length > 0"
        >
          Estamp Details
        </span>
        <div
          *ngFor="let estamp of estampForms.controls; let i = index"
          class="form_outline_sty mt-1"
        >
          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Second Party Name <span class="color_red">*</span></span
              >
              <input
                placeholder="Enter second party name"
                class="form-control"
                formControlName="secondPartyName"
                pInputText
                type="text"
                maxlength="50"
                onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 32"
              />
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('secondPartyName')?.hasError('required')
                "
                >*Enter Second Party Name</span
              >
            </div>
            <div class="form_inputFields">
              <span class="form_field ms-2">
                Execution Date <span class="color_red">*</span></span
              >
              <div style="display: block" class="">
                <p-datepicker
                  #calendar
                  class="custom-calendar"
                  formControlName="execution_date"
                  [minDate]="minDate"
                  placeholder="Select Date"
                  [showIcon]="true" iconDisplay="input"
                  [readonlyInput]="false"
                  inputId="dateformat"
                  dateFormat="dd/mm/yy"
                >
                </p-datepicker>
              </div>
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('execution_date')?.hasError('required')
                "
                >*Enter Date</span
              >
            </div>
          </div>

          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Stamp Duty Value <span class="color_red">*</span></span
              >
              <input
                class="form-control"
                formControlName="stampDutyValue"
                placeholder="Enter stamp Duty Value"
                pInputText
                type="number"
                (keypress)="numberOnly($event)"
              />
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('stampDutyValue')?.hasError('required')
                "
                >*Enter value</span
              >
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="estamp.get('stampDutyValue')?.hasError('min')"
                >*Stamp Duty cannot be less than 10</span
              >
            </div>

            <div class="form_inputFields">
              <span class="form_field ms-2">
                Stamp Duty Paid By <span class="color_red">*</span></span
              >
              <div style="display: block" class="overlay">
                <app-dropdown
                  [options]="stampDutyPaidByOptions"
                  class="custom-dropdown"
                  placeholder="Select stamp duty paid by"
                  [autoDisplayFirst]="false"
                  optionLabel="name"
                  optionValue="code"
                  formControlName="stampDutyPaidBy"
                ></app-dropdown>
              </div>
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('stampDutyPaidBy')?.hasError('required')
                "
                >*Select Paid By</span
              >
            </div>
          </div>
        </div>
      </form>

      <form [formGroup]="editEsignForm">
        <span
          class="title_five ms-2"
          *ngIf="selectedOrderForEdit.esign.length > 0"
        >
          Esign Details
        </span>
        <div
          *ngFor="let esign of esignForms.controls; let i = index"
          class="form_outline_sty mt-1"
        >
          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Name <span class="color_red">*</span></span
              >
              <input
                placeholder="Enter second party name"
                class="form-control"
                formControlName="name"
                pInputText
                type="text"
                maxlength="50"
                onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 32"
              />
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="submitted && esign.get('name')?.hasError('required')"
                >*Enter Second Party Name</span
              >
            </div>
            <div class="form_inputFields">
              <span class="form_field ms-2">
                Email <span class="color_red">*</span></span
              >
              <input
                class="form-control edit_input"
                formControlName="email"
                placeholder="Enter Email"
                pInputText
                type="text"
              />
              <span
                class="p-error"
                *ngIf="submitted && esign.get('email')?.hasError('required')"
                >*Enter valid Email
              </span>
            </div>
          </div>

          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Contact Number <span class="color_red">*</span></span
              >
              <input
                class="form-control edit_input"
                formControlName="contact_number"
                placeholder="Enter Number"
                pInputText
                type="text"
                (keypress)="numberOnly($event)"
              />
              <span
                class="p-error"
                *ngIf="
                  submitted && esign.get('contact_number')?.hasError('required')
                "
                >*Mobile Number is required</span
              >
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="update-edit-footer">
      <div class="btnRow me-3 mt-2">
        <div>
          <p-button
            label="Cancel"
            (click)="closeEditOrderPopup()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
        <div>
          <p-button
            label="Save"
            (click)="editSelectedOrder()"
            class="ms-2"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewStampOrder let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Document</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="iframe_border">
      <iframe
        [src]="pdfSource"
        allow-same-origin
        class="col-md-12 text-center this-is-iframe"
        style="
          height: 40rem;
          border-width: thin;
          background-color: #ffffff;
          transform: scale(1);
          transform-origin: top;
        "
      ></iframe>
    </div>
  </div>
</ng-template>

<ng-template #viewExcel let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Excel Table</h4>
    <div class="text-right custom_button">
      <p-button
        class="me-5"
        label="Excel"
        (click)="downloadExcel()"
        icon="bx bx-download"
        styleClass="p-button-sm-outline"
      ></p-button>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        (click)="closeModel()"
        aria-label="Close"
      ></button>
    </div>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 80vh">
    <div class="container mb-5">
      <div class="mt-1 table_styleing">
        <table class="table table-bordered">
          <thead class="modal-bg align-middle">
            <tr class="modal-bg">
              <th class="modal-bg" *ngFor="let header of jsonData[0]">
                {{ header }}
              </th>
            </tr>
          </thead>

          <tbody class="tablebody">
            <tr style="margin-top: 20px" *ngFor="let row of jsonData.slice(1)">
              <td *ngFor="let cell of row; let colIndex = index">
                {{ formatDate(cell, colIndex) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <app-view-order [viewOrderId]="viewOrderId"></app-view-order>
  </div>
</ng-template>